export default __webpack_public_path__ + "img/da3d9590a19fddc6678c326d6a230fd4.svg";